// extracted by mini-css-extract-plugin
export default {"wrap":"QuizStepperProgress_wrap__agetB","top":"QuizStepperProgress_top__4ZhET","item":"QuizStepperProgress_item__k09Tq","active":"QuizStepperProgress_active__LmPaq"};